import { Box, type SxProps, type Theme } from "@mui/material";
import React from "react";

type ComparisonBreakdownPanelProps = {
  title: React.ReactNode;
  meta?: React.ReactNode;
  actions?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  className?: string;
};

const basePanelSx: SxProps<Theme> = {
  overflow: "auto",
  bgcolor: "white",
  borderRadius: "24px",
  px: 3,
  py: 3,
  boxShadow: "0 4px 14px rgba(147, 197, 253, 0.45)",
};

export function ComparisonBreakdownPanel({
  title,
  meta,
  actions,
  footer,
  children,
  sx,
  className,
}: ComparisonBreakdownPanelProps) {
  return (
    <Box className={className} sx={[basePanelSx, ...(Array.isArray(sx) ? sx : [sx])]}>
      <div className="flex items-center justify-between gap-3 mb-6" aria-live="polite">
        <div className="flex items-center gap-4 flex-wrap">
          <h2 className="text-[20px] font-semibold text-[#001F3F]">{title}</h2>
          {meta}
        </div>
        {actions ? (
          <div className="flex items-center gap-4 flex-wrap justify-end">{actions}</div>
        ) : null}
      </div>
      {children}
      {footer}
    </Box>
  );
}
